//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
export default {
  name: "Header",
  data() {
    return {
      user: null,
      menus: [],
      activeIndex: "",
      businessType: "",
    };
  },
  watch: {
    "$store.state.headMenuPath": {
      handler(val) {
        this.activeIndex = val;
      },
    },
    "$route.query.$businessType": {
      handler(val) {
        this.businessType = val ? val : "";
        this.setMenus();
      },
    },
  },
  created() {
    this.businessType = this.$route.query.$businessType
      ? this.$route.query.$businessType
      : "";
    this.setMenus();
    let user = localStorage.getItem("user");
    if (user) {
      this.user = JSON.parse(user);
    }
    this.setMenus();
  },

  computed: {},
  methods: {
    ...mapActions(["saveHeadMenuPath"]),
    /**
     * @Description: 菜单切换
     * @Author: yangsibo
     * @Date: 2023-01-06 10:38:08
     * @param {*} val
     * @return {*}
     */
    selectMenu(val) {
      this.saveHeadMenuPath(val);
    },
    handleSelect(key, keyPath) {
      // if (!key) {
      //   return;
      // }

      // let path = "";
      // switch (key) {
      //   case "produceServe":
      //     path = "/farming/manage";
      //     break;
      //   case "capital":
      //     path = "/Capital/index";
      //     break;
      //   case "allOrder":
      //     path = "/all-order/capital/list";
      //     this.saveHeadMenuPath(path);
      //     this.activeIndex = path;
      //     break;
      // }
      // this.$router.push({ path: path });
    },
    handleSignOut() {
      localStorage.removeItem("user");
      localStorage.removeItem("loginTime");
      localStorage.removeItem("accessToken");
      this.saveHeadMenuPath("");
      location.reload();
    },
     /**
     * @description: 返回
     * @Author: yangsibo
     * @Date: 2022-06-23 09:08:31
     * @return {*}
     */
    handleBack() {
      this.$router.push({ path: this.$route.query.$backPath, query: {} });
    },
    setMenus() {
      let menuList = this.$router.options.routes.filter((item) => {
        return !item.meta.hidden;
      });
   
      if (
        this.$route.query.$businessType &&
        this.$route.query.$businessType === "_blank"
      ) {
        this.menus = [
          {
            meta: {
              title: this.$route.query.$businessName,
            },
          },
        ];
        this.activeIndex = null;
      } else {
        this.menus = menuList[0].children;
        this.$nextTick(() => {
          this.activeIndex =
            this.$store.state.headMenuPath || this.menus[0].path;
        });
      }
    },
  },
};
